import { VictoryBar, VictoryGroup, VictoryTooltip } from 'victory';
import { patterns } from './patterns/Patterns';
import { getBarChartProps } from './helpers/getBarChartProps';
import { formatNumber } from '@dop/shared/helpers/string';
import { Label } from '../Label';
import { colors } from '@/uiPrimitives/color/colors.css';
import { axisFontStyle, fontStyle, toolTipProps } from '../cbsGraph.config';

export const Bars = ({
	barOffset,
	barInlineSize,
	valuesByComparingDimension,
	decimals,
	unit,
	containerId,
}: { barOffset: number; barInlineSize: number; containerId: string } & Pick<
	ReturnType<typeof getBarChartProps>,
	'valuesByComparingDimension' | 'decimals' | 'unit'
>) => {
	return (
		<VictoryGroup offset={barOffset}>
			{valuesByComparingDimension.map(
				({ dataList, key, title: comparingTitle }, index) => {
					const { color, darkColor } = patterns[index];
					return (
						<VictoryBar
							horizontal
							key={key}
							data={[...dataList].reverse()}
							barWidth={Math.min(40, barInlineSize)}
							y={'value'}
							x={'axisLabel'}
							style={{
								data: {
									fill: ({ datum }) => {
										const { id, color } = patterns[datum._stack - 1];

										return `url(#${containerId}-${id}) ${color}`;
									},
									stroke: ({ datum }) => {
										const { color } = patterns[datum._stack - 1];

										return color;
									},
									strokeWidth: 0.5,
								},
							}}
							labels={({ datum: { value, title } }) => {
								return [
									`${formatNumber({
										number: value,
										decimals,
									})} (${unit})`,
									' ',
									title,
									comparingTitle || ' ',
								];
							}}
							labelComponent={
								<VictoryTooltip
									{...toolTipProps}
									orientation={'bottom'}
									flyoutStyle={{
										strokeWidth: 2,
										stroke: darkColor,
										fill: 'white',
									}}
									labelComponent={
										<Label
											style={[
												{
													...axisFontStyle,
													fill: color,
												},
												{ fontSize: 10 },
												{
													...fontStyle,
													fill: colors.text.positive.muted,
												},
												{
													...fontStyle,
													fill: colors.text.positive.muted,
													fontStyle: 'italic',
												},
											]}
										/>
									}
								/>
							}
						/>
					);
				},
			)}
		</VictoryGroup>
	);
};
